import axios from 'axios';

// Create a configured axios instance that always sends the auth token
const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Add auth token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('blvx-session-token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

if (process.env.NODE_ENV === 'development') {
  api.interceptors.request.use((config) => {
    console.log('[API Request]', config.method?.toUpperCase(), config.url);
    return config;
  });
}

// Global 401 handler — registered by AuthContext on mount
let _unauthorizedHandler = null;
export const setUnauthorizedHandler = (fn) => { _unauthorizedHandler = fn; };

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && _unauthorizedHandler) {
      _unauthorizedHandler();
    }
    return Promise.reject(error);
  }
);

export default api;
